module.exports = __webpack_public_path__ + "static/media/3.68166390.svg";